<template>
    <v-dialog v-model="$store.state.assignment.dialog" width="600px" persistent>
        <v-card>
            <v-toolbar color="secondary" dense>
                <v-spacer></v-spacer>
                <v-toolbar-title class="white--text"
                    >New Assignments</v-toolbar-title
                >
                <v-spacer></v-spacer>
                <v-btn
                    icon
                    dark
                    @click="$store.state.assignment.dialog = false"
                >
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-toolbar>
            <v-container grid-list-xs fluid>
                <v-row>
                    <v-col cols="12" style="margin-top: 0px; border-top: 0px">
                        <v-combobox
                            v-model="driver"
                            :items="data[0].drivers"
                            :item-text="'Name'"
                            :item-value="'id'"
                            label="Select Driver"
                            class="ma-5"
                            @change="chargeDriverShift"
                            auto-select-first
                        ></v-combobox>
                    </v-col>
                </v-row>

                <v-form ref="formSearch" v-model="valid" lazy-validation>
                    <v-row>
                        <v-col cols="4">
                            <v-combobox
                                dense
                                class="mt-2"
                                v-model="truck"
                                :items="data[0].trucks"
                                :item-text="'Truck'"
                                :item-value="'TruckID'"
                                :rules="[v => !!v || 'Required']"
                                required
                                label="Select Truck"
                                auto-select-first
                                @change="changeTruck()"
                            ></v-combobox>
                        </v-col>
                        <v-col cols="4">
                            <v-combobox
                                dense
                                class="mt-2"
                                v-model="trailer"
                                :items="data[0].trailers"
                                :item-text="'Trailer'"
                                :item-value="'id'"
                                :rules="[v => !!v || 'Required']"
                                required
                                label="Select Trailer"
                                auto-select-first
                                @change="changeTrailer()"
                            ></v-combobox>
                        </v-col>
                        <v-col cols="4">
                            <v-combobox
                                dense
                                class="mt-2"
                                v-model="yard"
                                :items="data[0].yards"
                                :item-text="'Yard'"
                                :rules="[v => !!v || 'Required']"
                                required
                                label="Select Yard"
                                :item-value="'id'"
                                auto-select-first
                                @change="changeYard()"
                            ></v-combobox>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="4">
                            <v-text-field
                                name="R"
                                label="Replacement Unit"
                                v-model="replacementU"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="4">
                            <v-text-field
                                name="R"
                                label="Start Time"
                                :rules="[v => !!v || 'Required']"
                                v-model="starTime"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="4">
                            <v-text-field
                                name="R"
                                label="Target Hours"
                                :rules="[v => !!v || 'Required']"
                                v-model="targetH"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                </v-form>
                <v-row>
                    <v-spacer></v-spacer>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="success"
                        class="mr-5"
                        @click="validateFormSearch"
                        >Add</v-btn
                    >
                </v-row>
            </v-container>
        </v-card>
    </v-dialog>
</template>
<script>
import axios from 'axios';
export default {
    props: ['data'],
    data: function() {
        return {
            driver: null,
            truck: null,
            trailer: null,
            yard: null,
            valid: true,
            startTime: '',
            trailerID: 0,
            truckID: 0,
            yardID: 0,

            replacementU: '',
            targetH: '12',
            starTime: ''
        };
    },
    methods: {
        validateFormSearch() {
            if (this.$refs.formSearch.validate() == false) {
                this.$refs.formSearch.validate();
            } else {
                this.addDriverShift();
            }
        },
        addDriverShift: function() {
            this.$store.state.isLoading = true;
            var str = this.$store;
            var parms = {
                ShiftHeaderNum: this.data[0].header.ShiftId,
                Driver: this.driver.id,
                Truck: this.truckID,
                Trailer: this.trailerID,
                TruckYard: this.yardID,
                ShiftStartTime: this.starTime,
                TargetHours: this.targetH,
                ReplacementUnit: this.replacementU,
                HrsAviable: this.targetH,
                NewAvialable:this.starTime,
            };
            console.log(parms);
            axios
                .post('shift-detail', parms, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                // eslint-disable-next-line no-unused-vars
                .then(response => {
                    str.dispatch('setSnackbar', {
                        color: 'success',
                        text: 'New Assignment successifly'
                    });
                    str.state.assignment.new = false;
                    str.state.assignment.dialog = false;
                })
                .catch(function(error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'warning',
                            text: 'This driver has no previous Shift. You have to write one.'
                        });
                    }
                });
            this.$store.state.isLoading = false;
        },
        changeTruck: function() {
            this.truckID = this.truck.TruckID;
            console.log(this.truckID);
        },
        changeTrailer: function() {
            this.trailerID = this.trailer.id;
            console.log(this.trailerID);
        },
        changeYard: function() {
            this.yardID = this.yard.id;
            console.log(this.yardID);
        },
        chargeDriverShift: function() {
            this.$store.state.isLoading = true;
            console.log(this.data);

            this.starTime = this.data[0].header.ShiftDate;
            console.log(this.starTime);
            var str = this.$store;
            if (this.driver && this.data[0].header.ShiftId) {
                this.dataLoading = true;
                axios
                    .post(
                        'shift-detail/copy/driver/' +
                            this.driver.id +
                            '/' +
                            this.data[0].header.ShiftId,
                        '',
                        {
                            headers: {
                                Authorization:
                                    'Bearer ' + this.$store.state.token
                            }
                        }
                    )
                    // eslint-disable-next-line no-unused-vars
                    .then(response => {
                        var result = response.data;
                        console.log(result);

                        this.starTime = result[0].ShiftStartTime;
                        this.replacementU = '';
                        this.yard = result[0].yard.Yard;
                        this.truck = result[0].truck.Truck;

                        this.yardID = result[0].yard.YardId;
                        this.truckID = result[0].truck.TruckID;
                        
                        if(result[0].Trailer === null){
                        }else{
                            this.trailer = result[0].trailer.Trailer;
                            this.trailerID = result[0].trailer.TrailerId;
                        }
                    })
                    .catch(function(error) {
                        console.log(error);
                        if (error.response.status === 403) {
                            str.dispatch('setSnackbar', {
                                color: 'error',
                                text:
                                    'You do not have the permission to use this function.'
                            });
                        }
                        if (error.response.status === 500) {
                            str.dispatch('setSnackbar', {
                                color: 'warning',
                                text: 'This driver has no previous Shift. You have to write one.'
                            });
                        }
                    });
            }
            this.$store.state.isLoading = false;
        }
    }
};
</script>
